import { z } from "zod";

// ─── Alert Type ─────────────────────────────────────────────────────────────

export const alertTypeSchema = z.enum(["changelog", "maintenance", "promotion", "info"]);
export type AlertType = z.infer<typeof alertTypeSchema>;

// ─── Alert Target Role ──────────────────────────────────────────────────────

export const alertTargetRoleSchema = z.enum(["all", "owner", "admin", "member"]);
export type AlertTargetRole = z.infer<typeof alertTargetRoleSchema>;

// ─── Create / Update Input ──────────────────────────────────────────────────

export const createAlertInputSchema = z.object({
  title: z.string().min(1, "Title is required").max(200),
  body: z.string().min(1, "Body is required").max(5000),
  type: alertTypeSchema,
  targetRoles: z.array(alertTargetRoleSchema).min(1, "At least one target role is required"),
});
export type CreateAlertInput = z.infer<typeof createAlertInputSchema>;

export const updateAlertInputSchema = z.object({
  title: z.string().min(1).max(200).optional(),
  body: z.string().min(1).max(5000).optional(),
  type: alertTypeSchema.optional(),
  targetRoles: z.array(alertTargetRoleSchema).min(1).optional(),
});
export type UpdateAlertInput = z.infer<typeof updateAlertInputSchema>;

// ─── Alert Response ─────────────────────────────────────────────────────────

export const alertSchema = z.object({
  id: z.string(),
  title: z.string(),
  body: z.string(),
  type: alertTypeSchema,
  targetRoles: z.array(z.string()),
  createdBy: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Alert = z.infer<typeof alertSchema>;

export const adminAlertSchema = alertSchema.extend({
  readCount: z.number(),
  totalTargetUsers: z.number(),
});
export type AdminAlert = z.infer<typeof adminAlertSchema>;
